<div class="wrapper" id="shell-wrapper">

  <mat-toolbar class="merlin_mainToolBar" id="mainToolBarBg">
    <mat-toolbar-row>
      <div class="col-xs-3">
        <div class="box">
          <figure class="brand-logo"></figure>
        </div>
      </div>
      <div class="col-xs-9 col-xs-end">
        <div class="box">
          <div class="helperLinks">
            @if (!isSignedOn) {
              <a mat-button>
                {{ labels['label.gb.signin'] }}
              </a>
            }
            @if (
              userProfile?.customerName &&
              userProfile?.customerName?.length > 0
              ) {
              <span class="cust_name">
                {{ labels['label.gb.clinic_name']}} &#8942;
                {{ userProfile?.customerName }}&nbsp;&nbsp;&nbsp;
              </span>
            }
            @if (isSignedOn) {
              <a mat-button>
                <span class="signintext"> {{ labels['label.gb.signedin'] }} &#8942;</span>
                @if (!isImpersonatedUser()) {
                  <span class="first_last_name" (click)="myaccount()"
                    matTooltip="{{ getLastLogin() }}">
                    {{ firstName ? (firstName[0] + " " + lastName) : "" }}
                  </span>
                }
                @if (isImpersonatedUser()) {
                  <span (click)="myaccount()" matTooltip="{{ getLastLogin() }}">
                    {{ loginAs }}
                  </span>
                }
                @if (role === _role.Admin) {
                  <span [matMenuTriggerFor]="admin_menu" #trigger="matMenuTrigger">
                  {{ labels['label.gb.help'] }} &#8942;</span>
                }
                @if (role === _role.User) {
                  <span [matMenuTriggerFor]="menu" #trigger="matMenuTrigger">{{
                  labels['label.gb.help'] }} &#8942;</span>
                }
                <mat-menu #admin_menu="matMenu">
                  <button mat-menu-item class="help-menu-item" (click)="onAdminHelpClick()">
                    {{ labels['label.gb.help'] }}
                  </button>
                  <button mat-menu-item class="help-menu-item" (click)="onAdminLearnMoreClick()">
                    {{ labels['leftNav.learn_more'] }}
                  </button>
                  <button (click)="openHelpDialog('practice')" mat-menu-item class="help-menu-item" >
                    {{ labels['leftNav.practice_site'] }}
                  </button>
                  <button (click)="openHelpDialog('about')" mat-menu-item class="help-menu-item" >
                    {{ labels['label.gb.about'] }}
                  </button>
                </mat-menu>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="onHelpClick()" class="help-menu-item" >
                    {{ labels['label.gb.help'] }}
                  </button>
                  <button mat-menu-item (click)="onLearnMoreClick()" class="help-menu-item" >
                    {{ labels['leftNav.learn_more'] }}
                  </button>
                  <button mat-menu-item (click)="openPracticeSiteData()" class="help-menu-item" >
                    {{ labels['leftNav.practice_site'] }}
                  </button>
                  <button mat-menu-item (click)="openAboutData()" class="help-menu-item" >
                    {{ labels['label.gb.about'] }}
                  </button>
                  @if (showOtherLanguageHelpLinks()) {
                    <button mat-menu-item [matMenuTriggerFor]="otherLinks" #trigger="matMenuTrigger" class="help-menu-item" >
                      {{ labels['label.gb.help_other_lang'] }}
                    </button>
                  }
                </mat-menu>
                <mat-menu #otherLinks="matMenu">
                  @for (langHelp of languageHelpLinks; track langHelp) {
                    <button mat-menu-item (click)="onHelpOtherLangLink(langHelp.link)" class="help-menu-item" >
                      {{ langHelp.label }}
                    </button>
                  }
                </mat-menu>
                <span (click)="logout()" class="text-trans-none">{{
                  labels['label.gb.signout']
                }}</span>
              </a>
            }
          </div>
                    <div class="textLogo pr-10 logoLower" [innerHTML]="
                            labels['label.gb.title.merlin.pcn']
                                | safe: 'html'
                        "></div>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <!-- 
    This logic was implemented to make it so
    1) gate the child components from rendering until we receive the strings from the API
    2) prevent this logic from occuring on first time so it does not slow down the login page
    3) the components on the login page have a signal effect that reparses their labels
  -->
  @if (!wasLoggedInAfterRefresh || stringsApiCompleted) {
    @if (isSignedOn) {
      <merlin-menu [enableSubMenu]="enableSubMenu" [menuData]="menuDataSource" #merlinMenu></merlin-menu>
    }
    <!-- Conditionally omit #app-container id for home page to allow full-bleed design -->
    <div [attr.id]="isHomePage ? null : 'app-container'">
      <router-outlet></router-outlet>
      @if (isImpersonatedUser()) {
        <div id="impersonate__user" class="impersonate__user" [innerHTML]="impersonateMessage"></div>
      }
      <merlin-footer class="footer" [footerData]="footerData" [copyRights]="footerCopyRights" [footerClass]="fooMenuClass" [copyrightClass]=""></merlin-footer>
    </div>
  }
</div>

<app-session-timeout [message]="idleState" (extendClicked)="extendClicked()"></app-session-timeout>
